import { EYE_TEST_ID } from "./constants";

// Haversine formula to calculate the distance between two points (in km)
export const haversineDistance = (coords1, coords2) => {
  const toRad = (value) => (value * Math.PI) / 180;

  const lat1 = coords1.lat;
  const lon1 = coords1.lng;
  const lat2 = coords2.lat;
  const lon2 = coords2.lng;

  const R = 6371; // Radius of the Earth in km
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in km
  return distance;
}


// Function to format date in YYYY-MM-DD format
export const formatDate = (date) => {
  if(!date) return ""
  return date.toLocaleDateString('en-CA') // 'en-CA' gives you the YYYY-MM-DD format
}


export const formatDateLong = (dateString) => {

  const date = new Date(dateString)

  const dayOptions = { weekday: 'long' } // For 'Tuesday'
  const dayOfMonth = date.getDate() // For '12'

  // Format the ordinal day (e.g., '12th')
  const ordinalDay = dayOfMonth + (dayOfMonth % 10 === 1 && dayOfMonth !== 11 ? 'st' : (dayOfMonth % 10 === 2 && dayOfMonth !== 12 ? 'nd' : (dayOfMonth % 10 === 3 && dayOfMonth !== 13 ? 'rd' : 'th')))

  const monthOptions = { month: 'long' } // For 'November'
  const yearOptions = { year: 'numeric' } // For '2024'

  const day = date.toLocaleDateString('en-GB', dayOptions) // Outputs 'Tuesday'
  const month = date.toLocaleDateString('en-GB', monthOptions) // Outputs 'November'
  const year = date.toLocaleDateString('en-GB', yearOptions) // Outputs '2024'

  return `${day} ${ordinalDay} ${month} ${year}`
}


export const formatLocation = (location) => {
  const street = location.PIAB__Street__c           // Street address
  const city = location.PIAB__City__c               // City
  const state = location.PIAB__State__c             // State
  const postalCode = location.PIAB__Postal_Code__c  // Postal code

  // Combine into a formatted string
  return `${street}, ${city} ${state} ${postalCode}`
}


export const formatTestType = (testType) => {
  if(testType === EYE_TEST_ID) return "Eye Test"
  return "Contact Lenses"
}


export const formatCustomerName = (customer) => {
  return `${customer.salutation} ${customer.firstName} ${customer.lastName}`
}


export const formatPhoneNumber = (phoneNumber) => {
  // Assuming the phone number is 10 digits long
  return phoneNumber.replace(/(\d{4})(\d{3})(\d{3})/, "$1 $2 $3")
}

export const getAssetUrl = (path) => {
  return (window.reactAppBaseUrl || '') + path
}